import { InjectionToken } from '@angular/core';

export const LAYOUTS_CONFIG = new InjectionToken('LayoutsConfig');

export interface IGrid {
  phone: number;
  tablet: number;
  desktop: number;
}

export interface ILayouts {
  grids: IGrid;
  elements: IGrid;
}

export const layoutsConfig: ILayouts = {
  grids: {
    phone: 0,
    tablet: 575,
    desktop: 1168,
  },
  elements: {
    phone: 1,
    tablet: 2,
    desktop: 3,
  },
};

export const LAYOUTS_CONFIG_PROVIDER = {
  provide: LAYOUTS_CONFIG,
  useValue: layoutsConfig,
};
